/** Netxol One's version, built into the console (vite.config.ts, from the root package.json). Only the number is shown. */
declare const __NETXOL_VERSION__: string;
export const NETXOL_VERSION: string = typeof __NETXOL_VERSION__ === 'string' ? __NETXOL_VERSION__ : '';
export const versionLabel = () => (NETXOL_VERSION ? `v${NETXOL_VERSION}` : '');
